import React from "react";
import { Col, Row, Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider,{ Search  } from "react-bootstrap-table2-toolkit";
import "../../www/css/style.css";
const { SearchBar } = Search;
export default function DatatableExpand({ data, columns, keyProp,expandRow,exportD,searchs}: any) {
  const MyExportCSV = (props:any) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <Button color="info" onClick={ handleClick }>Exportar!</Button>
      </div>
    );
  };

  return (
    <ToolkitProvider keyField={keyProp} data={data} columns={columns}  exportCSV>
      {(props:any) => (
        <React.Fragment>
          <Row>
            <Col sm={12} className="text-right">
            {exportD && (
            <MyExportCSV { ...props.csvProps } />
            )}
            </Col>
            <Col sm={12} className="mt-2">
              {searchs && (<SearchBar { ...props.searchProps } />)}
        <hr />
              <BootstrapTable {...props.baseProps}  expandRow={ expandRow }/>
            </Col>
          </Row>
        </React.Fragment>
      )}
    </ToolkitProvider>
  );
}
